import { TwilioError } from "twilio-video";
import { boolean } from "yup";
import { Organization } from "./organization";

import { User } from "./user";

export enum SessionTiming {
  ACTIVE,
  PAST,
  FUTURE,
  UNKNOWN
}

export enum SessionStatus {
  Scheduled = "Scheduled",
  Cancelled = "Cancelled",
  Completed = "Completed",
  NoShow = "NoShow"
}

export type Session = {
  id: string;
  title: string;
  user_id: string;
  participants: User[];
  coach_id: string;
  coach: User;
  start_time: Date;
  end_time: Date;
  instance_count: number;
  use_server: boolean;
  status: SessionStatus;
  billable: boolean;
  createdAt: Date;
  updatedAt: Date;
  organization?: Organization;
  iassert_response?: string;
};
export type ErrorCallback = (error: TwilioError | Error) => void;
